export const REFRESH_TOKEN_COOKIE = '__danIN_rt';
export const FIREBASE_TOKEN_COOKIE = '__danIN_fmc';
export const FIREBASE_NOTIFICATION_COOKIE = '__danIN_fnotc';
